module.exports = __webpack_public_path__ + "static/media/To-Do-List.944bfd5d.png";